import React from 'react';
import { LayoutGrid, Users, BarChart2, Settings, Search, Bell, HelpCircle } from 'lucide-react';
import { Avatar } from './ui/Avatar';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex h-screen w-full bg-gray-50" data-id="element-6">
      {/* Sidebar */}
      <div className="w-16 md:w-64 bg-white border-r border-gray-200 flex flex-col" data-id="element-7">
        <div className="p-4 border-b border-gray-200" data-id="element-8">
          <h1 className="text-xl font-bold hidden md:block" data-id="element-9">Wonderflow</h1>
          <div className="md:hidden flex justify-center" data-id="element-10">
            <div className="w-8 h-8 bg-blue-600 rounded-md flex items-center justify-center text-white font-bold" data-id="element-11">
              W
            </div>
          </div>
        </div>
        <nav className="flex-1 p-2" data-id="element-12">
          <ul className="space-y-1" data-id="element-13">
            <NavItem icon={<LayoutGrid size={20} data-id="element-15" />} label="Dashboard" data-id="element-14" />
            <NavItem icon={<BarChart2 size={20} data-id="element-17" />} label="Insights" data-id="element-16" />
            <NavItem icon={<Users size={20} data-id="element-19" />} label="Workspaces" active={true} data-id="element-18" />
            <NavItem icon={<Settings size={20} data-id="element-21" />} label="Settings" data-id="element-20" />
          </ul>
        </nav>
        <div className="p-4 border-t border-gray-200" data-id="element-22">
          <div className="flex items-center" data-id="element-23">
            <Avatar name="John Doe" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" data-id="element-24" />
            <div className="ml-3 hidden md:block" data-id="element-25">
              <p className="text-sm font-medium" data-id="element-26">John Doe</p>
              <p className="text-xs text-gray-500" data-id="element-27">john@example.com</p>
            </div>
          </div>
        </div>
      </div>
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-28">
        {/* Header */}
        <header className="bg-white border-b border-gray-200 h-16 flex items-center px-4" data-id="element-29">
          <div className="flex-1 flex items-center" data-id="element-30">
            <div className="relative w-64" data-id="element-31">
              <input type="text" placeholder="Search..." className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-32" />
              <div className="absolute left-3 top-2.5 text-gray-400" data-id="element-33">
                <Search size={18} data-id="element-34" />
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-35">
            <button className="text-gray-500 hover:text-gray-700" data-id="element-36">
              <Bell size={20} data-id="element-37" />
            </button>
            <button className="text-gray-500 hover:text-gray-700" data-id="element-38">
              <HelpCircle size={20} data-id="element-39" />
            </button>
          </div>
        </header>
        {/* Content */}
        <main className="flex-1 overflow-auto bg-gray-50 p-6" data-id="element-40">{children}</main>
      </div>
    </div>;
}
function NavItem({
  icon,
  label,
  active = false
}: {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
}) {
  return <li data-id="element-41">
      <a href="#" className={`flex items-center p-2 rounded-md ${active ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-42">
        <span className="flex-shrink-0" data-id="element-43">{icon}</span>
        <span className="ml-3 hidden md:block" data-id="element-44">{label}</span>
      </a>
    </li>;
}